<div class="agpr-themeSentimentAnalytics">
    <!-- Cards -->
    <div
        class="agpr-themeSentimentAnalytics-chartWrapperHorizontal"
        [id]="id + '.sentiment' + '.smallChart'">
        <agpr-card-chart
            class="agpr-themeSentimentAnalytics-smallChart"
            [series]="[positiveSeries, previousPeriodPositiveSeries]"
            [color]="cardChartComponentHighlightColorEnum.positive"
            [bubbleTooltipMetric]="socialMetrics.POSITIVE_VOLUME"
            [hidePrevious]="isArchiveSearch"
            headingLevel="4"
        >
        </agpr-card-chart>
        <agpr-card-chart
            class="agpr-themeSentimentAnalytics-smallChart"
            [series]="[negativeSeries, previousPeriodNegativeSeries]"
            [color]="cardChartComponentHighlightColorEnum.negative"
            [bubbleTooltipMetric]="socialMetrics.NEGATIVE_VOLUME"
            [hidePrevious]="isArchiveSearch"
            headingLevel="4"
        >
        </agpr-card-chart>
    </div>

    <!-- Sentiment summary -->
    <div
        [agprLoading]="sentimentSummaryChartLoading"
        [overlayStyleClass]="'agpr-themeSentimentAnalytics-chartLoading'"
        class="agpr-themeSentimentAnalytics-chartContainer agpr-contextMenu-parent"
        #sentimentSummaryChartElement
        [id]="id + '.sentiment' + '.chartLoading'"
    >
        <div class="agpr-themeSentimentAnalytics-exportMenu agpr-contextMenu top right">
            <agpr-chart-export-menu
                id="sentimentSummary_export"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="supportedExportFormats"
                (exportMenuClicked)="exportChart($event, sentimentSummaryChartElement, themeAnalyticsChartTypeEnum.SENTIMENT_SUMMARY)"
                [social]="true"
                [contextMenu]="true"
            ></agpr-chart-export-menu>
        </div>
        <agpr-chart
            *ngIf="sentimentSummaryChart"
            [showLoadingUntil]="chartLoadingOptionsEnum.none"
            [chart]="sentimentSummaryChart"
        ></agpr-chart>
        <div #sentimentSummaryChartLegend class="agpr-themAnalyticsSummary-customLegendContainer"></div>
    </div>

    <!-- Sentiment by Social Network Comparison -->
    <div
        class="agpr-themeSentimentAnalytics-chartWrapper agpr-contextMenu-parent"
        #sentimentBySocialNetworkElement
        [id]="id + '.sentiment' + '.sentimentBySocialNetworkComparisonChart'"
    >
        <div class="agpr-themeSentimentAnalytics-tabsWrapper">
            @if (showSentimentBySocialNetworkTrendChart) {
                    <label class="agpr-themeSentimentAnalytics-title">{{ 'Social.intelligence.themeAnalytics.sentiment.socialNetworkComparison.title' | localize }}</label>
                    <div class="agpr-themeSentimentAnalytics-tabsContent">
                        <div class="agpr-themeSentimentAnalytics-summaryTrend-header-container">
                            <agpr-tabs
                                [(selectedTabIndex)]="selectedSentimentTrendNetworkChartTabIndex"
                                (selectedTabIndexChange)="sentimentTrendNetworkChartStackTypeChanged($event)"
                            >
                                <agpr-tab
                                    [id]="'themeSentimentAnalytics_sentimentTrendChart_percentage'"
                                    [heading]="'Social.intelligence.themeAnalytics.sentimentTrend.' + stackTypes.percent"
                                ></agpr-tab>
                                <agpr-tab
                                    [id]="'themeSentimentAnalytics_sentimentTrendChart_volume'"
                                    [heading]="'Social.intelligence.themeAnalytics.sentimentTrend.' + stackTypes.count"
                                ></agpr-tab>
                            </agpr-tabs>
                        </div>
                        <button
                        class="agpr-themeSentimentAnalytics-chartToggleButton"
                        (click)="hideSentimentTrendBySocialNetwork()"
                    >
                        <span [pTooltip]="'Social.intelligence.themeAnalytics.sentiment.backToComparison' | localize" class="fa-solid fa-duotone fa-circle-chevron-right agpr-themeSentimentAnalytics-chartToggleButton-chartToggleButtonLabel" aria-hidden="true"></span>
                    </button>
                    </div>
                }
        </div>
        <div class="agpr-themeSentimentAnalytics-exportMenu agpr-contextMenu top right">
            <agpr-chart-export-menu
                id="sentimentBySocialNetwork_export"
                *ngIf="!showSentimentBySocialNetworkTrendChart"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="supportedExportFormats"
                (exportMenuClicked)="exportChart($event, sentimentBySocialNetworkElement, themeAnalyticsChartTypeEnum.SENTIMENT_BY_SOCIAL_MEDIA_COMPARISON)"
                [social]="true"
                [contextMenu]="true"
            ></agpr-chart-export-menu>
            <agpr-chart-export-menu
                id="sentimentBySocialNetwork_export"
                *ngIf="showSentimentBySocialNetworkTrendChart"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="supportedExportFormats"
                (exportMenuClicked)="exportChart($event, sentimentBySocialNetworkElement, themeAnalyticsChartTypeEnum.SOCIAL_MEDIA_SENTIMENT_TREND)"
                [social]="true"
                [contextMenu]="true"
            ></agpr-chart-export-menu>
        </div>
        <agpr-chart
            [chart]="sentimentBySocialNetworkComparisonChart"
            [ngClass]="showSentimentBySocialNetworkTrendChart ? 'agpr-themeSentimentAnalytics--hidden' : 'agpr-themeSentimentAnalytics--visible'"
        ></agpr-chart>
        <agpr-am5-chart
            [chart]="socialNetworkTrendChart"
            [series]="socialNetworkTrendSeries"
            [ngClass]="showSentimentBySocialNetworkTrendChart ? 'agpr-themeSentimentAnalytics--visible' : 'agpr-themeSentimentAnalytics--hidden'"
            (noContent)="updateSocialNetworkTrendChartNoData($event)"
            (tooltipLinkClick)="openSocialTrendDrilldown($event, socialNetworkTrendChart)"
        ></agpr-am5-chart>
    </div>

    <!-- Sentiment by Social Topic Comparison -->
    <div
        *ngIf="!isArchiveSearch"
        class="agpr-themeSentimentAnalytics-chartWrapper agpr-contextMenu-parent"
        [class]="{
            'agpr-themeSentimentAnalytics-chartWrapper--large': hasTooManyResources
        }"
        #sentimentBySocialTopiclement
        [id]="id + '.sentiment' + '.sentimentBySocialTopicComparisonChart'"
    >
        <div class="agpr-themeSentimentAnalytics-tabsWrapper">
            @if (showSentimentBySocialTopicTrendChart) {
                <label class="agpr-themeSentimentAnalytics-title">{{ 'Social.intelligence.themeAnalytics.sentiment.socialTopicComparison.title' | localize }}</label>
                <div class="agpr-themeSentimentAnalytics-tabsContent">
                    <div class="agpr-themeSentimentAnalytics-summaryTrend-header-container">
                        <agpr-tabs
                            [(selectedTabIndex)]="selectedSentimentTrendTopicChartTabIndex"
                            (selectedTabIndexChange)="sentimentTrendTopicChartStackTypeChanged($event)"
                        >
                            <agpr-tab
                                [id]="'themeSentimentTopicAnalytics_sentimentTrendChart_percentage'"
                                [heading]="'Social.intelligence.themeAnalytics.sentimentTrend.' + stackTypes.percent"
                            ></agpr-tab>
                            <agpr-tab
                                [id]="'themeSentimentTopicAnalytics_sentimentTrendChart_volume'"
                                [heading]="'Social.intelligence.themeAnalytics.sentimentTrend.' + stackTypes.count"
                            ></agpr-tab>
                        </agpr-tabs>
                    </div>
                <button
                    class="agpr-themeSentimentAnalytics-chartToggleButton"
                    (click)="hideSentimentTrendBySocialTopic()"
                >
                    <span [pTooltip]="'Social.intelligence.themeAnalytics.sentiment.backToComparison' | localize" class="fa-solid fa-duotone fa-circle-chevron-right agpr-themeSentimentAnalytics-chartToggleButton-chartToggleButtonLabel" aria-hidden="true"></span>
                </button>
            </div>
            }
        </div>
        <div class="agpr-themeSentimentAnalytics-exportMenu agpr-contextMenu top right">
            <agpr-chart-export-menu
                id="sentimentBySocialTopic_export"
                *ngIf="!showSentimentBySocialTopicTrendChart"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="supportedExportFormats"
                (exportMenuClicked)="exportChart($event, sentimentBySocialTopiclement, themeAnalyticsChartTypeEnum.SENTIMENT_BY_SOCIAL_TOPIC_COMPARISON)"
                [social]="true"
                [contextMenu]="true"
            ></agpr-chart-export-menu>
            <agpr-chart-export-menu
                id="sentimentBySocialTopic_export"
                *ngIf="showSentimentBySocialTopicTrendChart"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="supportedExportFormats"
                (exportMenuClicked)="exportChart($event, sentimentBySocialTopiclement, themeAnalyticsChartTypeEnum.SOCIAL_TOPIC_SENTIMENT_TREND)"
                [social]="true"
                [contextMenu]="true"
            ></agpr-chart-export-menu>
        </div>
        <agpr-chart
            [chart]="sentimentBySocialTopicComparisonChart"
            [ngClass]="showSentimentBySocialTopicTrendChart ? 'agpr-themeSentimentAnalytics--hidden' : 'agpr-themeSentimentAnalytics--visible'"
        ></agpr-chart>
        <agpr-am5-chart
            [chart]="socialTopicTrendChart"
            [series]="socialTopicTrendSeries"
            [ngClass]="showSentimentBySocialTopicTrendChart ? 'agpr-themeSentimentAnalytics--visible' : 'agpr-themeSentimentAnalytics--hidden'"
            (noContent)="updateSocialTopicTrendChartNoData($event)"
            (tooltipLinkClick)="openSocialTrendDrilldown($event, socialTopicTrendChart)"
        ></agpr-am5-chart>
    </div>

    <!-- Positive Top posts -->
    <div
        *ngIf="positiveTopPostsSeries"
        class="agpr-themeSentimentAnalytics-chartContainer"
        [id]="id + '.sentiment' + '.positiveTopPostsSeries'"
    >
        <agpr-top-posts
            [id]="id + '.sentiment' + '.positiveTopPosts'"
            [title]="'Social.intelligence.themeAnalytics.sentiment.topPostsPositive'"
            [series]="positiveTopPostsSeries"
            [availableNetworkTypes]="enabledNetworkTypes"
            [chartElementRef]= "topPostsPositiveElement"
            [enableEngagementInsights]="!isArchiveSearch || (isArchiveSearch && enableEngagementInsights)"
        >
        </agpr-top-posts>
    </div>

    <!-- Negative Top posts -->
    <div
        *ngIf="negativeTopPostsSeries"
        class="agpr-themeSentimentAnalytics-chartContainer"
        [id]="id + '.sentiment' + '.negativeTopPostsSeries'"
    >
        <agpr-top-posts
            [id]="id + '.sentiment' + '.negativeTopPosts'"
            [title]="'Social.intelligence.themeAnalytics.sentiment.topPostsNegative'"
            [series]="negativeTopPostsSeries"
            [availableNetworkTypes]="enabledNetworkTypes"
            [chartElementRef]= "topPostsNegativeElement"
            [enableEngagementInsights]="!isArchiveSearch || (isArchiveSearch && enableEngagementInsights)"
        >
        </agpr-top-posts>
    </div>

    <!-- Positive Top Terms -->
    <agpr-top-terms
        *ngIf="positiveTopTermsSeries"
        [id]="id + '.sentiment' + '.topterms.positive'"
        sentimentType="positive"
        [series]="positiveTopTermsSeries"
        [availableNetworkTypes]="enabledNetworkTypes"
        [initialMetric]="mentionSearchFacetTypesEnum.hashtags"
        [config]="topTermsPositiveConfig"
    ></agpr-top-terms>

    <!-- Negative Top Terms -->
    <agpr-top-terms
        *ngIf="negativeTopTermsSeries"
        [id]="id + '.sentiment' + '.topterms.negative'"
        sentimentType="negative"
        [series]="negativeTopTermsSeries"
        [availableNetworkTypes]="enabledNetworkTypes"
        [initialMetric]="mentionSearchFacetTypesEnum.hashtags"
        [config]="topTermsNegativeConfig"
        [accentColor]="defaultChartColors.sentimentColors.negative"
    ></agpr-top-terms>
</div>
